import { createSevenroomsVenueGroup } from '@store/venue/integrations/SevenroomsVenueGroupReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import Create from './Create'

export const SevenroomsVenueGroupForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.sevenroomsVenueGroup)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createSevenroomsVenueGroup(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

SevenroomsVenueGroupForm.displayName = 'SevenroomsVenueGroupForm'

export default SevenroomsVenueGroupForm
